import moment from 'moment'
import type { AppointmentDtoRecurrenceTemplate } from '~/clinician-api/models'
import type { Client } from './client'

export enum EventType {
  CLIENT_SESSION = 'client-session',
  OTHER_EVENT = 'other-event'
}

export enum NotificationType {
  CANCEL = 'cancel',
  UPDATE = 'update',
  CONFIRM = 'confirm'
}

export const EVENT_SETTING_TELEHEALTH = 'telehealth'
export const EVENT_SETTING_IN_PERSON = 'in-person'
export const EVENT_SETTING_OPTIONS = [
  EVENT_SETTING_TELEHEALTH,
  EVENT_SETTING_IN_PERSON
]
export type EventSetting = (typeof EVENT_SETTING_OPTIONS)[number]

export interface ServiceType {
  code: string
  text: string
}

export class BpEvent {
  readonly eventType: EventType
  readonly id?: string
  readonly subject?: string
  readonly serviceType?: ServiceType
  readonly start: string
  readonly end: string
  readonly setting: EventSetting
  readonly patient?: Client
  readonly recurring: string
  readonly recurrenceTemplate?: AppointmentDtoRecurrenceTemplate
  readonly notes?: string
  readonly clinician_id: string
  readonly isNewClient?: boolean
  readonly sourceCalendarType?: string

  constructor(data: Partial<BpEvent>) {
    this.eventType = data.eventType || EventType.CLIENT_SESSION
    this.id = data.id
    this.patient = data.patient
    this.subject = data.subject || ''
    this.serviceType = data.serviceType
    this.start =
      data.start ||
      moment()
        .startOf('hour')
        .add(moment().minutes() < 30 ? 30 : 60, 'minutes')
        .toISOString()
    this.setting = data.setting || EVENT_SETTING_TELEHEALTH
    this.end =
      data.end ||
      moment()
        .startOf('hour')
        .add(moment().minutes() < 30 ? 30 : 60, 'minutes')
        .add(30, 'minutes')
        .toISOString()
    this.recurring = data.recurring || 'no-repeat'
    this.recurrenceTemplate = data.recurrenceTemplate
    this.notes = data.notes
    this.clinician_id = data.clinician_id || ''
    this.isNewClient = data.isNewClient || false
    this.sourceCalendarType = data.sourceCalendarType
  }

  withChanges(changes: Partial<BpEvent>): BpEvent {
    return new BpEvent({ ...this, ...changes })
  }

  getDuration(): number {
    return moment(this.end).diff(moment(this.start), 'minutes')
  }
}
